import {POST_MESSAGE} from "@/repositories/api/contact/postMessage";
export const messageWs = {
    POST_MESSAGE
};